import React from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';

import { ParkingName } from 'components/common';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: '5px', marginBottom: '5px'
  },
  formControl: {
    minWidth: theme.spacing(20),
    height: '55px',
    width: '100%',
    '& .MuiInput-underline:before': {
      display: 'none',
    },
    '& .MuiInput-underline:after': {
      display: 'none',
    },
    borderRadius: '10px',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.base.white,
    paddingTop: '10px',
    marginTop: '10px', marginBottom: '5px'
  },
  selectEmpty: {
    borderRadius: 0,
    '&:before, &:hover:before': {
      border: 0,
    },
    '& > select': {
      height: '200px',
      padding: theme.spacing(1.25, 5, 1.25, 1.25),
      fontFamily: 'Segoe UI',
      fontSize: 13,
      lineHeight: '17px',
      color: theme.palette.base[300],
    },
    '& > svg': {
      width: 16,
      height: 16,
      fill: theme.palette.secondary.main,
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  },
  option: {
    cursor: 'pointer',
    '&:hover': {
      background: theme.palette.secondary.main,
      color: theme.palette.base.white,
    },
  },
  container: {
    display: 'flex', direction: 'row'
  },
  placeholder: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    textTransform: 'none',
    fontSize: 14,
    marginLeft: '20px',
    '& span': {
      margin: theme.spacing(0, 1.5),
    },
    color: 'white'
  },
  placeholder2: {
    display: 'flex',
    fontSize: 16,
    marginLeft: 'auto',
    marginRight: '20px',
    '& span': {
      margin: theme.spacing(0, 1.5),
    },
    color: 'white'
  },
}));

const ParkingSelect = (props) => {
  const classes = useStyles();

  const {
    parkings,
    placeholder,
    items,
    handleChange,
  } = props;

  const onChange = (event) => {
    handleChange(event.target.value);
  };

  const MenuProps = {
    elevation: 0,
    getContentAnchorEl: 0,
    transitionDuration: 0,
    transformOrigin: {
      vertical: 'top',
    },
    PaperProps: {
      style: {
        width: 250,
        maxHeight: 'calc(100%/1.25 - 200px)',
        top: '100px'
      },
    },
  };

  return (
    <div className={classes.root}>
      <FormControl className={classes.formControl}>
        <Select
          value=""
          onChange={onChange}
          className={classes.selectEmpty}
          variant="standard"
          MenuProps={MenuProps}
          displayEmpty
        >
          <MenuItem
            value=""
            className={classes.option}
            disabled
          >
            <div className={classes.container}>
              <div className={classes.placeholder}>
                <span>{placeholder}</span>
              </div>
              <div className={classes.placeholder2}> <AddIcon /> </div>
            </div>

          </MenuItem>
          {items.map((item) => (
            <MenuItem
              value={item.value}
              key={item.key}
              className={classes.option}
            >
              <ParkingName parking={parkings.find((p) => p.parkingId === item.id)} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

ParkingSelect.propTypes = {
  parkings: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  items: PropTypes.array,
  handleChange: PropTypes.func,
};

ParkingSelect.defaultProps = {
  placeholder: '',
  items: [],
  handleChange: null,
};

export default ParkingSelect;
